import React from "react";

export default class FieldsToShowItem extends React.Component {
  handleAggregationFunctionChange = (event) => {
    const value = event.target.value;
    this.props.onAggregationFunctionChange(value, this.props.itemKey);
  };

  handleAliasChange = (event) => {
    const value = event.target.value;
    this.props.onAliasChange(value, this.props.itemKey);
  };

  handleGroupByChange = () => {
    this.props.onGroupByChange(this.props.itemKey);
  };

  handleShowMetadataChange = () => {
    this.props.onShowMetadataChange(this.props.itemKey);
  };

  render() {
    const {
      item,
      itemKey,
      isEnumerated,
      isGroupByUsed,
      groupBy,
      showMetadata,
      alias,
      aggregationFunction,
      isPrimaryCube,
      hasForeignCubes,
      cubeName,
    } = this.props;

    const variable = item.items.find((x) => x.object.type === "Variable");

    const labelTitleCube = isPrimaryCube
      ? `Primary cube: ${cubeName}\n`
      : `Foreign cube: ${cubeName}\n`;
    const labelTitle = `${hasForeignCubes ? labelTitleCube : ""}Variable: ${
      variable.object.name || "[No name]"
    } (${
      item.object.cubeVariableCode
    })\nRole: ${item.object.role.toUpperCase()}\nDesc: ${
      variable.object.description || "[No description]"
    }`;

    return (
      <React.Fragment>
        <div className="item-texts" title={labelTitle}>
          {hasForeignCubes && (
            <React.Fragment>
              <div className="item-text item-text-cube">{cubeName}</div>{" "}
              <div className="item-text-type">
                <span className="object-type label label-success">Cube</span>
                {" - "}
              </div>
            </React.Fragment>
          )}
          <div className="item-text">
            {`${variable.object.name || "[No name]"} (${
              item.object.cubeVariableCode
            }) `}
          </div>
          <div className="item-text-type">
            <span className="object-type label label-success">Variable</span>
          </div>
        </div>
        {isGroupByUsed && !groupBy && (
          <div className="aggregation-function">
            <select
              className="form-control"
              value={aggregationFunction}
              onChange={this.handleAggregationFunctionChange}
            >
              <option value="">- Select -</option>
              <option value="MIN">MIN</option>
              <option value="MAX">MAX</option>
              <option value="AVG">MEAN</option>
              <option value="SUM">SUM</option>
              <option value="COUNT">COUNT</option>
            </select>
          </div>
        )}
        <div className="alias">
          <input
            type="text"
            value={alias}
            placeholder="Alias..."
            className="form-control"
            onChange={this.handleAliasChange}
          />
        </div>
        <div className="group-by">
          <input
            title="Group by"
            type="checkbox"
            id={`${itemKey}_groupby`}
            checked={groupBy}
            onChange={this.handleGroupByChange}
          />
        </div>
        <div className="group-by">
          <input
            disabled={!isEnumerated}
            title={isEnumerated ? "Show metadata" : "Item is not enumerated"}
            type="checkbox"
            id={`${itemKey}_show-metadata`}
            checked={showMetadata}
            onChange={this.handleShowMetadataChange}
          />{" "}
        </div>
        <label className="hidden">Group by</label>{" "}
      </React.Fragment>
    );
  }
}
